/* GrowthOS — Leads "Columns" show/hide menu (ported from design LeadsList).
   Drives AG Grid column visibility; presentational shell + a toggle callback. */
import { useEffect, useRef } from 'react';

const COLUMNS_ICON = 'M3 4h18v16H3V4ZM9 4v16M15 4v16';
const CHECK_ICON = 'M20 6 9 17l-5-5';

const CIcon = ({ d, size = 15 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const LeadsColumns = ({ columns, hidden, onToggle, onToggleAll, open, setOpen }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open, setOpen]);

  const hiddenCount = columns.filter((c) => hidden.has(c.id)).length;
  const toggleable = columns.filter((c) => !c.locked);
  const allShown = toggleable.length > 0 && toggleable.every((c) => !hidden.has(c.id));

  return (
    <div className="gos-cols-wrap" ref={ref}>
      <button
        type="button"
        className={'gos-btn gos-btn-ghost gos-filter-btn' + (open ? ' on' : '')}
        onClick={() => setOpen((o) => !o)}
      >
        <CIcon d={COLUMNS_ICON} />
        Columns
        {hiddenCount ? <span className="count">{columns.length - hiddenCount}</span> : null}
      </button>
      {open && (
        <div className="dropdown gos-cols-menu">
          <div className="col-menu-head">
            <span className="menu-label" style={{ padding: 0 }}>Show columns</span>
            <button type="button" className="col-toggle-all" onClick={onToggleAll}>
              {allShown ? 'Hide all' : 'Show all'}
            </button>
          </div>
          <div className="gos-cols-list">
            {columns.map((col) => {
              const visible = !hidden.has(col.id);
              return (
                <div
                  key={col.id}
                  className={'dropdown-item gos-cols-item' + (col.locked ? ' is-locked' : '')}
                  onClick={col.locked ? undefined : () => onToggle(col.id)}
                >
                  <span className={'lead-check sm' + (visible ? ' on' : '')}>
                    {visible ? <CIcon d={CHECK_ICON} size={11} /> : null}
                  </span>
                  {col.label}
                  {col.locked ? <span className="col-lock-note">Always</span> : null}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadsColumns;
